<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Lottery List
        </h4>
        <div class="d-flex align-items-center" style="gap: 10px;">
          <input type="text" class="form-control" placeholder="Search lottery..." style="width: 240px;"
            [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" />
          <a href="javascript: void(0);" class="btn btn-primary text-nowrap"
            (click)="openModal(editModal, {}, 'Add Lottery')" ngbTooltip="Add Lottery">
            + Add Lottery
          </a>
        </div>
      </div>

      <div class="table-responsive mt-4">
        <div *ngIf="loading" class="text-center py-4">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>

        <table class="table table-striped border" *ngIf="!loading">
          <thead class="table-light">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Lottery Name</th>
              <th scope="col">Expiry Date</th>
              <th scope="col">Required Orders</th>
              <th scope="col">Winner Type</th>
              <th scope="col">IsEnable</th>
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of list; let i = index; trackBy: trackById">
              <td>{{ (page - 1) * pageSize + i + 1 }}</td>
              <td>{{ item?.lotteryName }}</td>
              <td>{{ item?.expiryDate | date: 'mediumDate' }}</td>
              <td>{{ item?.requiredOrders }}</td>
              <td>
                <span class="badge"
                  [ngClass]="item?.winnerSelectionType === 'multiple' ? 'badge-info' : 'badge-secondary'">
                  {{ item?.winnerSelectionType | titlecase }}
                </span>
              </td>
              <td>
                <ui-switch [(ngModel)]="item.isEnabled" [name]="'status_' + item._id"
                  (ngModelChange)="toggleStatus(item)"></ui-switch>
              </td>
              <td>
                <span class="badge" [ngClass]="item?.status === 'active' ? 'badge-success' : 'badge-secondary'">
                  {{ item?.status | titlecase }}
                </span>
              </td>
              <td>
                <a [routerLink]="['/user/lottery-participants', item._id]" class="link mr-2"
                  ngbTooltip="View Participants">
                  <i class="fa fa-eye"></i>
                </a>
                <a href="javascript:void(0);" class="link mr-2" (click)="openModal(editModal, item, 'Edit Lottery')"
                  ngbTooltip="Edit">
                  <i class="fa fa-edit"></i>
                </a>
                <a href="javascript:void(0);" class="link mr-2 " (click)="openDeleteModal(deleteModal, item._id)"
                  ngbTooltip="Delete">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>

            <tr *ngIf="list?.length === 0 && !loading">
              <td colspan="7" class="text-center text-muted">
                No lottery records found.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-center mt-3" *ngIf="!loading && list?.length > 0">
          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalCount" [maxSize]="7"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add / Edit Modal -->
<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modeltitle }}</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (ngSubmit)="onSubmit()" #lotteryForm="ngForm">
    <div class="modal-body">

      <div class="form-group">
        <label>Lottery Name <span class="text-danger">*</span></label>
        <input type="text" class="form-control" name="lotteryName" [(ngModel)]="detail.lotteryName"
          placeholder="Enter lottery name" required #lotteryName="ngModel"
          [class.is-invalid]="lotteryName.invalid && (lotteryName.dirty || lotteryName.touched)" />
        <div class="invalid-feedback" *ngIf="lotteryName.invalid && (lotteryName.dirty || lotteryName.touched)">
          Lottery name is required
        </div>
      </div>

      <!-- <div class="form-group" *ngIf="!detail._id">
        <label>Store Location ID <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          name="storeLocationId"
          [(ngModel)]="detail.storeLocationId"
          placeholder="Enter store location ID"
          required
          #storeLocationId="ngModel"
          [class.is-invalid]="storeLocationId.invalid && (storeLocationId.dirty || storeLocationId.touched)"
        />
        <div class="invalid-feedback" *ngIf="storeLocationId.invalid && (storeLocationId.dirty || storeLocationId.touched)">
          Store location ID is required
        </div>
      </div> -->

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Expiry Date <span class="text-danger">*</span></label>
            <input type="date" class="form-control" name="expiryDate" [(ngModel)]="detail.expiryDate" required
              #expiryDate="ngModel"
              [class.is-invalid]="expiryDate.invalid && (expiryDate.dirty || expiryDate.touched)" />
            <div class="invalid-feedback" *ngIf="expiryDate.invalid && (expiryDate.dirty || expiryDate.touched)">
              Expiry date is required
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Required Orders <span class="text-danger">*</span></label>
            <input type="number" class="form-control" name="requiredOrders" [(ngModel)]="detail.requiredOrders"
              placeholder="Enter required orders" required min="1" #requiredOrders="ngModel"
              [class.is-invalid]="requiredOrders.invalid && (requiredOrders.dirty || requiredOrders.touched)" />
            <div class="invalid-feedback"
              *ngIf="requiredOrders.invalid && (requiredOrders.dirty || requiredOrders.touched)">
              Required orders is required
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="!detail._id">
          <div class="form-group">
            <label>Winner Selection Type <span class="text-danger">*</span></label>
            <select class="form-control" name="winnerSelectionType" [(ngModel)]="detail.winnerSelectionType" required
              #winnerSelectionType="ngModel" (ngModelChange)="onWinnerTypeChange()"
              [class.is-invalid]="winnerSelectionType.invalid && (winnerSelectionType.dirty || winnerSelectionType.touched)">
              <option value="">Select type</option>
              <option *ngFor="let type of winnerSelectionTypes" [value]="type">
                {{ type | titlecase }}
              </option>
            </select>
            <div class="invalid-feedback"
              *ngIf="winnerSelectionType.invalid && (winnerSelectionType.dirty || winnerSelectionType.touched)">
              Winner selection type is required
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Minimum Order Value <span class="text-danger">*</span></label>
            <input type="number" class="form-control" name="minimumOrderValue" [(ngModel)]="detail.minimumOrderValue"
              placeholder="Enter minimum order value" required min="0" #minimumOrderValue="ngModel"
              [class.is-invalid]="minimumOrderValue.invalid && (minimumOrderValue.dirty || minimumOrderValue.touched)" />
            <div class="invalid-feedback"
              *ngIf="minimumOrderValue.invalid && (minimumOrderValue.dirty || minimumOrderValue.touched)">
              Minimum order value is required
            </div>
          </div>
        </div>
      </div>

      <!-- Winner Configuration -->
      <div class="form-group">
        <label class="d-flex justify-content-between align-items-center">
          <span>Winner Configuration <span class="text-danger">*</span></span>
          <button *ngIf="detail.winnerSelectionType !== 'single'" type="button" class="btn btn-sm btn-outline-primary"
            (click)="addWinnerRow()">
            <i class="fa fa-plus"></i> Add Winner
          </button>
        </label>
        <table class="table table-bordered table-sm mt-2">
          <thead class="table-light">
            <tr>
              <th>Rank</th>
              <th>Prize Amount</th>
              <th *ngIf="detail.winnerSelectionType !== 'single'"></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let winner of detail.winnerConfiguration; let wi = index">
              <td style="width: 120px;">
                <input type="number" class="form-control form-control-sm" [name]="'rank_' + wi"
                  [(ngModel)]="winner.rank" placeholder="Rank" required min="1" />
              </td>

              <td>
                <input type="number" class="form-control form-control-sm" [name]="'prizeAmount_' + wi"
                  [(ngModel)]="winner.prizeAmount" placeholder="Prize amount" required min="0" />
              </td>

              <!-- Hide remove button when single -->
              <td *ngIf="detail.winnerSelectionType !== 'single'" style="width: 60px;" class="text-center">
                <button type="button" class="btn btn-sm btn-danger" (click)="removeWinnerRow(wi)"
                  [disabled]="detail.winnerConfiguration.length === 1">
                  <i class="fa fa-times"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="lotteryForm.invalid">
        {{ detail._id ? 'Update Lottery' : 'Add Lottery' }}
      </button>
    </div>
  </form>
</ng-template>

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Lottery</h5>
    <button type="button" class="close" (click)="closeDeleteModalClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    Are you sure you want to delete this lottery?
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeDeleteModalClick()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      Delete
    </button>
  </div>
</ng-template>